import React, { ReactElement } from 'react'
import Wallet from '../../../components/verification-steps/steps/wallet/Wallet'
import verificationStore from '../../../stores/verificaton.store'

const UserWallet: React.FC = (): ReactElement => {
  return <Wallet verificationStore={verificationStore} />
}

export default UserWallet
